export default "__VITE_ASSET__0b0a735f__"